/* eslint-disable arrow-body-style */
import axios, { AxiosPromise } from 'axios';
import { IRIS_ADMIN_API_PATH } from 'consts';
import { getOmjsViewInstance } from 'selectors';
import i18next from 'i18next';

export interface ICaptchaRequestResponse {
    SUCCESS: boolean;
    CAPTCHA_KEY?: string;
}

export const loadCaptcha = (): AxiosPromise<ICaptchaRequestResponse> => {
    if (__PROXY_URL__) {
        return axios.get(`${__PROXY_URL__}/local/form/requestCaptcha.php?security_code=${__SECURITY_CODE__}`);
    } else {
        // eslint-disable-next-line max-len
        return axios.get(`https://map.lenoblinvest.ru/local/form/requestCaptcha.php?security_code=${__SECURITY_CODE__}`);
    }
};

export const isTokenValid = async (token: string) => {
    let result = await axios.get<boolean>(
        `//${__HOST__}/api/${window['omjs'].version}/${__P_ID__}/authorized/`,
        { params: { token } }
    );
    return result.data;
};

export const directLogin = (user: string, pass: string) => {
    const viewInstance = getOmjsViewInstance(false);
    const { protocol, hostname } = viewInstance.getProject().apiUrlLocation;

    let form_data = new FormData();
    form_data.set('user', user);
    form_data.set('pass', pass);

    // return axios.post(`//${__HOST__}/api/${window['omjs'].version}/${__P_ID__}/login/`, form_data);
    return axios.post(`${protocol}//${hostname}/${IRIS_ADMIN_API_PATH}/user/login/`, form_data);
};

export const directLogout = (token: string) => {
    const viewInstance = getOmjsViewInstance(false);
    const { protocol, hostname } = viewInstance.getProject().apiUrlLocation;

    let form_data = new FormData();
    form_data.append('token', token);

    // return axios.post(`//${__HOST__}/api/${window['omjs'].version}/${__P_ID__}/logout/`, form_data);
    return axios.post(`${protocol}//${hostname}/${IRIS_ADMIN_API_PATH}/user/logout/`, form_data);
};

export const searchSitesPkk = (query: string, mapCode: string, limit: number = 5) => {
    const sql = 'SELECT orbis_id,geom,\'sites_1\'::text as "layer",cadastral_land_number_maps_ru,'
        + `name_${i18next.language} as "name" `
        + 'FROM iris_new.sites_1 '
        + `WHERE cadastral_land_number_maps_ru::text ~~ '%${query}%'::text UNION `
        + 'SELECT orbis_id,geom,\'sites_2\'::text as "layer",cadastral_land_number_maps_ru,'
        + `name_${i18next.language} as "name" `
        + 'FROM iris_new.sites_2 '
        + `WHERE cadastral_land_number_maps_ru::text ~~ '%${query}%'::text UNION `
        + 'SELECT orbis_id,geom,\'sites_3\'::text as "layer",cadastral_land_number_maps_ru,'
        + `name_${i18next.language} as "name" `
        + 'FROM iris_new.sites_3 '
        + `WHERE cadastral_land_number_maps_ru::text ~~ '%${query}%'::text UNION `
        + 'SELECT orbis_id,geom,\'sites_4\'::text as "layer",cadastral_land_number_maps_ru,'
        + `name_${i18next.language} as "name" `
        + 'FROM iris_new.sites_4 '
        + `WHERE cadastral_land_number_maps_ru::text ~~ '%${query}%'::text `
        + `LIMIT ${limit};`;
    // eslint-disable-next-line max-len
    return axios.get(`//${__HOST__}/api/${window['omjs'].version}/${__P_ID__}/${mapCode}/layers/sites_1/objects/?sql=${encodeURIComponent(sql)}&escape=0`);
};

export const getUserInfo = (token: string) => {
    const viewInstance = getOmjsViewInstance(false);
    const { protocol, hostname } = viewInstance.getProject().apiUrlLocation;
    return axios.get(`${protocol}//${hostname}/${IRIS_ADMIN_API_PATH}/user/info/?token=${token}`);
};
